import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'
import headshotImg from '../../assets/images/bio-headshot.png'

const Hero = ({
  className,
  bottomImage,
  bottomImageAlt = 'Company logos'
}) => {
  const [timeOfDay, setTimeOfDay] = useState('');

  useEffect(() => {
    const today = new Date();
    const hour = today.getHours();

    let time;
    if (hour < 12) {
      time = 'morning';
    } else if (hour < 17) {
      time = 'afternoon';
    } else {
      time = 'evening';
    }

    setTimeOfDay(time);
  }, []);

  function yearsExp(year) {
    const currentYear = new Date().getFullYear();
    return currentYear - year;
  }

  let experience = yearsExp(2009)

  return (
    <section className={classnames('hero', className)}>
      <header className="hero__header">
        <img className="hero__headshot" src={headshotImg} alt="me"/>
        <h1>G’{timeOfDay}, <NavLink to="bio">I&apos;m Drew</NavLink></h1>
        <h2>
          Senior Product Designer @Publix • AI Systems Engineer • Mentored ~100 students @CareerFoundry @Thinkful -
          Impacted 100M+ users at Publix, Walmart, It Works!, and Tropicana.
        </h2>
      </header>
      <p>I've spent the last {experience} years designing digital experiences across ecommerce, SaaS, and internal enterprise tools. My roots are in UX, but I've led teams, owned high risk problems, built systems, and helped shape strategy along the way.</p>
      <p>Today, I'm leading a large multi-year modernization of Publix’s mainframe system, creating a new AI intergration system that allows us to scale at a rapid pace. I also lead the design for internal facing Publix applications.</p>
      {bottomImage && (
        <img className="hero__bottom-image" src={bottomImage} alt={bottomImageAlt} />
      )}
    </section>
  );
};

export default Hero;
